import React, { Component } from 'react';
import { Link } from 'react-router'
import { Grid, Row, Col } from 'react-bootstrap';
import travolta from './travolta.gif';

import './style.css';

export default class NotFound extends Component {

  render() {
    return (
      <Grid>
        <Row className="not-found">
          <Col smOffset={3} sm={6}><h3><Link to="/">Fantasy Fitness Draft</Link></h3></Col>
        </Row>
        <Row className="not-found">
          <Col smOffset={3} sm={6}><h1 className="not-found">You lost Bro?</h1></Col>
        </Row>
        <Row>
          <Col smOffset={3} sm={6}><img className="not-found img-responsive" src={travolta} alt="Confused" /></Col>
        </Row>
      </Grid>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/NotFound/index.js